<template>
  <b-breadcrumb>
    <b-breadcrumb-item to="/competitors">
      Competitors
    </b-breadcrumb-item>
    <b-breadcrumb-item active>
      <span v-if="value">
        {{ value.candle_name }}
      </span>
    </b-breadcrumb-item>
  </b-breadcrumb>
</template>

<script>
export default {
  name: 'CompetitorBreadcrumbs',
  components: {},
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
</style>
